export const PRODUCT_LIST_DEFAULT_QUERY = ':size-asc:allCategories:';
export const PRODUCT_LIST_RELATED_PARTS_QUERY = ':isRelatedPart:';
